import { circlePath, starPath, heartPath } from "./artHelpers";

const s = { stroke: "#241531", strokeWidth: 2.4, strokeLinejoin: "round", strokeLinecap: "round" };

export const STICKERS = [
  {
    id: "ghosty",
    name: "Boo Buddy",
    art: (
      <g>
        <path
          d="M 10 30 C 10 12 20 6 24 6 C 28 6 38 12 38 30 L 38 42 C 35 46 32 43 30 45 C 28 47 25 46 24 43 C 23 46 20 47 18 45 C 16 43 13 46 10 42 Z"
          fill="#FFF7EE" {...s}
        />
        <circle cx="19" cy="24" r="2.6" fill="#241531" />
        <circle cx="29" cy="24" r="2.6" fill="#241531" />
        <ellipse cx="24" cy="31" rx="2.6" ry="3.4" fill="#FF7A00" {...s} strokeWidth="1.6" />
        <circle cx="14" cy="29" r="2" fill="#FF5CA8" opacity="0.7" />
        <circle cx="34" cy="29" r="2" fill="#FF5CA8" opacity="0.7" />
      </g>
    ),
  },
  {
    id: "pumpky",
    name: "Grin Patch",
    art: (
      <g>
        <path d="M 22 10 C 20 5 24 3 26 5 C 28 3 32 5 30 10" fill="#39FF14" {...s} strokeWidth="1.8" />
        <ellipse cx="24" cy="28" rx="17" ry="15" fill="#FF7A00" {...s} />
        <path d="M 14 24 L 21 24 L 17.5 31 Z" fill="#FFF7EE" {...s} strokeWidth="1.6" />
        <path d="M 27 24 L 34 24 L 30.5 31 Z" fill="#FFF7EE" {...s} strokeWidth="1.6" />
        <path d="M 15 33 L 20 37 L 24 33 L 28 37 L 33 33" fill="none" {...s} strokeWidth="1.8" />
      </g>
    ),
  },
  {
    id: "batling",
    name: "Flap Attack",
    art: (
      <g>
        <path d="M 8 20 C 12 12 20 12 24 18 C 28 12 36 12 40 20 C 34 18 30 22 32 27 C 28 24 25 26 24 30 C 23 26 20 24 16 27 C 18 22 14 18 8 20 Z" fill="#8A4FFF" {...s} />
        <circle cx="15" cy="19" r="1.4" fill="#241531" />
        <circle cx="33" cy="19" r="1.4" fill="#241531" />
      </g>
    ),
  },
  {
    id: "starburst",
    name: "Twinkle Toes",
    art: (
      <g>
        <path d={starPath(24, 24, 18)} fill="#FFD23F" {...s} />
        <circle cx="19" cy="21" r="1.8" fill="#241531" />
        <circle cx="29" cy="21" r="1.8" fill="#241531" />
        <path d="M 20 28 C 22 31 26 31 28 28" fill="none" {...s} strokeWidth="1.8" />
        <circle cx="16" cy="26" r="2" fill="#FF5CA8" opacity="0.7" />
        <circle cx="32" cy="26" r="2" fill="#FF5CA8" opacity="0.7" />
      </g>
    ),
  },
  {
    id: "candy",
    name: "Sugar Rush",
    art: (
      <g>
        <ellipse cx="24" cy="24" rx="12" ry="9" fill="#FF5CA8" {...s} />
        <path d="M 13 19 L 5 13 L 7 24 L 5 35 L 13 29 Z" fill="#FFD23F" {...s} strokeWidth="1.8" />
        <path d="M 35 19 L 43 13 L 41 24 L 43 35 L 35 29 Z" fill="#FFD23F" {...s} strokeWidth="1.8" />
        <path d="M 16 20 L 32 28" fill="none" {...s} strokeWidth="1.6" />
      </g>
    ),
  },
  {
    id: "kitty",
    name: "Slime Kitty",
    art: (
      <g>
        <path d="M 10 20 L 8 8 L 20 15 Z" fill="#39FF14" {...s} strokeWidth="1.8" />
        <path d="M 38 20 L 40 8 L 28 15 Z" fill="#39FF14" {...s} strokeWidth="1.8" />
        <circle cx="24" cy="27" r="15" fill="#39FF14" {...s} />
        <ellipse cx="18.5" cy="25" rx="2.6" ry="3.6" fill="#241531" />
        <ellipse cx="29.5" cy="25" rx="2.6" ry="3.6" fill="#241531" />
        <path d="M 22 31 L 26 31 L 24 34 Z" fill="#FF5CA8" {...s} strokeWidth="1.4" />
        <path d="M 24 34 C 22 37 19 37 18 35 M 24 34 C 26 37 29 37 30 35" fill="none" {...s} strokeWidth="1.4" />
      </g>
    ),
  },
  {
    id: "skully",
    name: "Choco Skull",
    art: (
      <g>
        <path d="M 12 24 C 12 12 20 8 24 8 C 28 8 36 12 36 24 C 36 30 33 33 30 35 L 30 40 L 18 40 L 18 35 C 15 33 12 30 12 24 Z" fill="#FFF7EE" {...s} />
        <circle cx="19" cy="23" r="3.4" fill="#241531" />
        <circle cx="29" cy="23" r="3.4" fill="#241531" />
        <path d="M 22 29 L 26 29 L 24 32 Z" fill="#FF7A00" {...s} strokeWidth="1.4" />
        <path d="M 20 40 L 20 44 M 24 40 L 24 44 M 28 40 L 28 44" {...s} strokeWidth="1.8" />
      </g>
    ),
  },
  {
    id: "moonbeam",
    name: "Night Light",
    art: (
      <g>
        <path d={circlePath(24, 24, 16)} fill="#FFD23F" {...s} />
        <circle cx="19" cy="20" r="3" fill="#FFF7EE" {...s} strokeWidth="1.4" />
        <circle cx="29" cy="27" r="2" fill="#FFF7EE" {...s} strokeWidth="1.4" />
        <path d={starPath(38, 10, 5)} fill="#39FF14" {...s} strokeWidth="1.4" />
        <path d={starPath(9, 34, 4)} fill="#39FF14" {...s} strokeWidth="1.4" />
      </g>
    ),
  },
  {
    id: "heartfang",
    name: "Fang Heart",
    art: (
      <g>
        <path d={heartPath(24, 24, 15)} fill="#FF5CA8" {...s} />
        <circle cx="19" cy="20" r="2" fill="#241531" />
        <circle cx="29" cy="20" r="2" fill="#241531" />
        <path d="M 21 26 L 23 31 L 25 26" fill="#FFF7EE" {...s} strokeWidth="1.6" />
      </g>
    ),
  },
  {
    id: "witchy",
    name: "Tiny Hat",
    art: (
      <g>
        <path d="M 14 30 L 24 6 L 34 30 Z" fill="#8A4FFF" {...s} />
        <ellipse cx="24" cy="32" rx="17" ry="5" fill="#8A4FFF" {...s} />
        <path d="M 20 24 L 28 24 L 27 29 L 21 29 Z" fill="#FFD23F" {...s} strokeWidth="1.6" />
      </g>
    ),
  },
];

export const STICKERS_BY_ID = Object.fromEntries(STICKERS.map((st) => [st.id, st]));
export const STICKER_IDS = STICKERS.map((st) => st.id);
